import { StyleSheet, Text, View } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

import { Block } from "src/core/components/pdf/shared/Block";
import { Title } from "src/core/components/pdf/shared/Title";
import { FolderFileType } from "src/core/components/pdf/shared/types";

type DiligencesSectionProps = {
  folderFile: FolderFileType;
};

const styles = StyleSheet.create({
  diligencesBlock: {
    backgroundColor: "#FDFDFE",
    borderWidth: 1,
    borderColor: "#E6E8ED",
    borderRadius: 12,
    padding: 12,
  },
  diligencesBlockEmpty: {
    backgroundColor: "#FDFDFE",
    borderWidth: 1,
    borderColor: "#E6E8ED",
    borderRadius: 12,
    padding: 12,
  },
  diligencesRow: {
    flexDirection: "row",
    alignItems: "flex-start",
  },
  diligencesText: {
    fontSize: 10,
    color: "#0A1A53",
    lineHeight: 1.4,
  },
});

export const DiligencesSection = ({ folderFile }: DiligencesSectionProps) => {
  const { t } = useTranslation();
  const diligences = folderFile?.diligences.filter((d) => d.selected) ?? [];

  const isEmpty = diligences.length === 0;

  return (
    <Block>
      <Title title={t("pdf.sections.diligences.title")} />

      <View style={isEmpty ? styles.diligencesBlockEmpty : styles.diligencesBlock}>
        {isEmpty ? (
          <Text style={styles.diligencesText}>{t("pdf.sections.diligences.noDiligences")}</Text>
        ) : (
          diligences.map((diligence) => (
            <View key={diligence.id} style={styles.diligencesRow}>
              <Text style={styles.diligencesText}>{diligence.name}</Text>
            </View>
          ))
        )}
      </View>
    </Block>
  );
};
